import { useEffect } from "react";

const VERSION_CHECK_INTERVAL = 60 * 1000; // alle 60 Sekunden

function useAutoUpdateCheck() {
  useEffect(() => {
    let currentVersion = null;

    async function checkVersion() {
      try {
        const res = await fetch("/version.json?_ts=" + Date.now(), {
          cache: "no-store"
        });
        const data = await res.json();

        if (currentVersion && data.version !== currentVersion) {
          console.log("New version available:", data.version);
          alert('New version available. The page will be reloaded to apply the update.');
          window.location.reload(true);
        } else {
          currentVersion = data.version;
        }
      } catch (err) {
        console.warn("Error checking version:", err);
      }
    }

    checkVersion(); // Initial check immediately
    const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
}

export default useAutoUpdateCheck;